import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { CheckAddressOutput } from '../utils/fstream';
import { setConfirmedZipCode } from '../reducers/zipCodeReducer';

export const useValidateZipCode = () => {
  const dispatch = useDispatch();

  const [zipValidationLoading, setZipValidationLoading] = useState(false);
  const [error, setError] = useState({ status: false, msg: '' });

  // THIS IS A FAKE ZIP CODE VALIDATION FUNCTION
  const fetchSuggestions = (input: string): CheckAddressOutput => {
    if (!input || input.length !== 5) {
      // If there is no searchTerm return an empty array
      return { status: 'error', isValid: false, msg: 'Enter a valid ZIP code' };
    }
    return { status: 'ok', isValid: true, msg: '' };
  };

  const setAlreadyValidZip = useCallback(
    (validZip: string) => {
      dispatch(setConfirmedZipCode(validZip));
    },
    [dispatch],
  );

  const validatingZip = async (inputValue: string) => {
    setZipValidationLoading(true);
    // const result = IS_LOCAL_ENV ? fetchSuggestions(inputValue) : await checkAddress(inputValue);
    const result = fetchSuggestions(inputValue);
    if (!result.isValid) {
      setError({
        status: true,
        msg: result?.status === 'ok' ? 'Enter a valid ZIP code' : '',
      });
      setZipValidationLoading(false);
      return;
    }
    dispatch(setConfirmedZipCode(inputValue));
    sessionStorage.setItem('validZipCode', inputValue);
    setZipValidationLoading(false);
  };

  return { validatingZip, setAlreadyValidZip, zipValidationLoading, error };
};
